import LocalMagicLayer from "./LocalMagicLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class newLevel1010GmNode extends cc.Component {

    @property({type:cc.ScrollView,displayName:"省份ScrollView"})
    provinceScrollView:cc.ScrollView = null;

    @property({type:cc.ScrollView,displayName:"城市ScrollView"})
    cityScrollView:cc.ScrollView = null;

    @property({type:cc.Node,displayName:"provinceItemContent"})
    provinceItemContent:cc.Node = null;

    @property({type:cc.Node,displayName:"cityItemContent"})
    cityItemContent:cc.Node = null;

    @property({type:cc.Node,displayName:"provinceItem"})
    provinceItem:cc.Node = null;

    @property({type:cc.Node,displayName:"cityItem"})
    cityItem:cc.Node = null;

    @property({type:cc.Label,displayName:"oneLabel"})
    oneLabel:cc.Label = null;
    @property({type:cc.Label,displayName:"twoLabel"})
    twoLabel:cc.Label = null;
    @property({type:cc.Label,displayName:"threeLabel"})
    threeLabel:cc.Label = null;
    @property({type:cc.Label,displayName:"fourLabel"})
    fourLabel:cc.Label = null;

    @property({type:LocalMagicLayer})
    gameScript:LocalMagicLayer = null;

    currentFixType:string = "0";
    
    provinceAry:string[] = [];
    cityAry:string[][] = [];

    selectType:string = "province";

    selectProvinceIndex:number = 0;

    oneStr:string = null;
    twoStr:string = null;
    threeStr:string = null;
    fourStr:string = null;

    complete?:()=>void = null;

    onLoad(){
        this.loadData("province");
    }

    start(): void {
        this.updateLabel();    
    }

    loadData(type:string){
        this.selectType = type;
        //@ts-ignore
        let province = DC.getProvs();
        let pproAry :string[] = [];
        for(let i =0;i<province.length;i++){
            let pro = province[i];
            let name = pro._name;
            pproAry.push(name);
        }
        switch(type){
            case "province":{
                    this.provinceAry = ["中国","特殊"];
                    this.cityAry = [pproAry,getSpecialProvince()];
                break;
            }
            case "city":{
                    let proAry:string[][] = [];
                    for(let i = 0; i<province.length;i++){
                        let citys = [];
                        let pro = province[i];
                        let cityMap = pro.mapCityId;
                        for(let key in cityMap){
                            let city = cityMap[key];
                            let name = city._name;
                            citys.push(name);
                        }
                        proAry.push(citys);
                    }
                    this.provinceAry = pproAry;
                    this.provinceAry.push("特殊");
                    this.cityAry = proAry.concat();
                    this.cityAry.push(getSpecialCity());
                break;
            }
        }
        this.loadItems();
    }

    loadItems(){
        let provinceNeedItemCount:number = this.provinceAry.length;
        let provinceItemCount:number = this.provinceItemContent.childrenCount;
        let provinceNeedCreateCount:number = provinceNeedItemCount - provinceItemCount;
        if(provinceNeedCreateCount > 0){
            for(let i =0;i<provinceNeedCreateCount;i++){
                let proItem = cc.instantiate(this.provinceItem);
                this.provinceItemContent.addChild(proItem);
            }
        }

        let cityNeedItemCount:number = this.cityAry[this.selectProvinceIndex].length;
        let cityItemCount:number = this.cityItemContent.childrenCount;
        let cityNeedCreateCount:number = cityNeedItemCount - cityItemCount;
        if(cityNeedCreateCount > 0){
            for(let i =0; i<cityNeedCreateCount;i++){
                let cityItem :cc.Node = cc.instantiate(this.cityItem);
                this.cityItemContent.addChild(cityItem);
            }
        }
        this.updateContent();
    }

    //更新Content
    updateContent(){
        this.provinceItemContent.children.forEach((n:cc.Node,index)=>{
            let provinceName = this.provinceAry[index];
            if(provinceName!=null){
                n.active = true;
                let labelNode = n.getChildByName("label");
                let label:cc.Label = labelNode.getComponent(cc.Label);
                label.string = provinceName;
            }else{
                n.active = false;
            }
        });
        this.cityItemContent.children.forEach((n:cc.Node,index)=>{
            let cityName = this.cityAry[this.selectProvinceIndex][index];
            if(cityName!=null){
                n.active = true;
                let labelNode = n.getChildByName("label");
                let label:cc.Label = labelNode.getComponent(cc.Label);
                label.string = cityName;
            }else{
                n.active = false;
            }
        });
    }

    //选择省份item
    selectProvinceItem(e:cc.Event.EventTouch){
        let node:cc.Node = e.target;
        let siblingIndex:number = node.getSiblingIndex();
        this.selectProvinceIndex = siblingIndex;
        this.loadItems();
    }

    //选择城市item
    selectCityItem(e:cc.Event.EventTouch){
        let node:cc.Node = e.target;
        let siblingIndex:number = node.getSiblingIndex();
        this.setData(this.cityAry[this.selectProvinceIndex][siblingIndex]);
    }

    onBtnFix(e:cc.Event.EventTouch,custom:string){
        this.currentFixType = custom;
        switch(custom){
            case "0":{
                this.loadData("province");
                break;
            }
            default:{
                this.loadData("city");
                break;
            }
        }
    }

    setData(str:string){
        switch(this.currentFixType){
            case "0":{
                this.oneStr = str;
                break;
            }
            case "1":{
                this.twoStr = str;
                break;
            }
            case "2":{
                this.threeStr = str;
                break;
            }
            case "3":{
                this.fourStr = str;
                break;
            }
        }
        this.updateLabel();
    }
    
    onBtnComit(){
        this.complete && this.complete();
        if(this.oneStr != null){
            this.gameScript.province = this.oneStr;
        }
        if(this.twoStr != null){
            this.gameScript.oneStr = this.twoStr;
        }
        if(this.threeStr != null){
            this.gameScript.twoStr = this.threeStr;
        }
        if(this.fourStr != null){
            this.gameScript.city = this.fourStr;
        }
        this.node.active = false;
    }

    updateLabel(){
        this.oneLabel.string = this.oneStr == null ? "" : this.oneStr;
        this.twoLabel.string = this.twoStr == null ? "" : this.twoStr;
        this.threeLabel.string = this.threeStr == null ? "" : this.threeStr;
        this.fourLabel.string = this.fourStr == null ? "" : this.fourStr;
    }
}


export function getSpecialProvince():string[]{
    return ["光之国","火星","仙府","三体星","赛博坦"];
}

export function getSpecialCity():string[]{
    return ["浪浪山","黄泉市","花果山","蔡徐村","老八市","马桶里"];
}
